import ApplicationController from "./application_controller";
import { FetchRequest } from '@rails/request.js'

/* This is the custom StimulusReflex controller for the Posts Reflex.
 * Learn more at: https://docs.stimulusreflex.com
 */
export default class extends ApplicationController {
  static targets = ["list", "organizationselect", "peoplelist"]

  connect() {
    console.log("say hi to the board collaborators controller!");
    this.boardId = this.element.dataset.boardid;
  }

  async changeOrganization(_e) {
    const orgId = this.organizationselectTarget.value;
    console.log("now load the people of " + orgId + " into " + this.peoplelistTarget);

    const request = new FetchRequest('get', `/boards/${this.boardId}/collaborators/organization/${orgId}`)
    const response = await request.perform()
    if (response.ok) {
      const html = await response.text
      this.peoplelistTarget.innerHTML = html
    }
  }

  async toggleCollaborator(e) {
    const card = e.target.closest('div.card')
    const userId = card.getAttribute('data-user-id')
    const checkbox = card.querySelector('input[type="checkbox"]')

    const orgId = this.organizationselectTarget.value
    const request = new FetchRequest('post', `/boards/${this.boardId}/collaborators/toggle`, {
      body: JSON.stringify({ user_id: userId })
    });

    const response = await request.perform()
    if (response.ok) {
      const html = await response.text
      card.outerHTML = html
    }
  }
  async updateRole(e) {
    const userId = e.target.getAttribute('data-user-id')
    const role = e.target.value
    console.log(userId, role)
    const request = new FetchRequest('put', `/boards/${this.boardId}/collaborators/${userId}/role`, {
      body: JSON.stringify({ role_id: role })
    });
    const response = await request.perform()
    if (response.ok) {
      const json = await response.json
      this.flash(json.message, "success")
    } else {
      this.flash("Update failed", "error")
    }
  }
}
